var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// 個人情報取り扱い等同意確認
import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { render } from 'react-dom';
import axios from '../axios';
import AgreementDocument from '../templates/AgreementDocument';
import { handleBrowzerBack } from '../BrowzerBack';
import { convertLine } from '../Convert';
// 使用する定数
// 同意文種別
import { clauses_type_list } from '../Const';
var GuarantorAgreementIndex = function () {
    // マイページ開設画面へ遷移
    var handleClickMypageEntry = function () {
        location.replace(process.env.MIX_MOCK_URL + "/entry");
    };
    // エラーメッセージ
    var _a = useState(), error_message = _a[0], setErrorMessage = _a[1];
    // 同意文の件名、本文のstate
    var init_agreement = { title: '', text: '', check_box_title: '' };
    var _b = useState(init_agreement), agreement_1 = _b[0], setAgreement1 = _b[1];
    /**
     * 同意文をstateにセット
     */
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var fetchLists = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get('/get_agreement', {
                                params: {
                                    clauses_type: clauses_type_list,
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        response.data.map(function (data, index) {
                            if (index === 0) {
                                setAgreement1(data);
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        // 同意文取得エラーメッセージを取得
                        setErrorMessage(error_1.response.data.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchLists();
    }, []);
    var agreement1 = function () {
        // 改行コードをセパレータにして文章を分解する
        var str_array = agreement_1['text'].split('\n');
        // ヘッダー２行を抜き出す
        var header = typeof str_array[0] !== 'undefined' && typeof str_array[1] !== 'undefined'
            ? str_array[0] + '\n' + str_array[1]
            : '';
        // ３行目以降を文字列連結する
        var body = '';
        for (var i = 2; i < str_array.length - 2; i++) {
            if (i > 2) {
                body += '\n';
            }
            body += str_array[i];
        }
        // フッター２行を抜き出す
        var footer_array = str_array.slice(-2);
        var footer = typeof footer_array[0] !== 'undefined' && typeof footer_array[1] !== 'undefined'
            ? footer_array[0] + footer_array[1]
            : '';
        return (React.createElement("div", null,
            React.createElement("div", { className: "p-heading3-box" },
                React.createElement("h3", { className: "heading3" }, agreement_1['title'])),
            React.createElement("div", { className: "paragraph text-center" }, convertLine(header)),
            React.createElement("div", { className: "paragraph" }, convertLine(body)),
            React.createElement("div", { className: "paragraph text-right" }, convertLine(footer))));
    };
    return (React.createElement("div", { className: "container l-main" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-11 col-sm-11 col-md-10 col-lg-10 mx-auto" })),
        React.createElement("h4", { className: "title text-center my-2 my-md-3" }, "\u5229\u7528\u898F\u7D04\u306E\u78BA\u8A8D"),
        error_message === undefined ? (
        // 同意文取得OK
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-11 col-sm-11 col-md-10 col-lg-10 mx-auto" },
                    React.createElement("p", null,
                        React.createElement("b", null,
                            "\u521D\u3081\u306B\u3001\u304A\u5BA2\u3055\u307E\u5C02\u7528\u306E\u300C\u30DE\u30A4\u30DA\u30FC\u30B8\u300D\u3092\u958B\u8A2D\u3044\u305F\u3057\u307E\u3059\u3002",
                            React.createElement("br", null),
                            "\u5229\u7528\u898F\u7D04\u3092\u3054\u78BA\u8A8D\u306E\u3046\u3048\u3001\u540C\u610F\u3044\u305F\u3060\u3051\u308B\u5834\u5408\u306F\u300C\u540C\u610F\u3059\u308B\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002")))),
            React.createElement(AgreementDocument, { check_box_title: agreement_1['check_box_title'], doc: agreement1() }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, sm: 12, md: 9, className: "mx-auto" },
                    React.createElement("button", { className: "c-btn btn-large confirm-btn js-confirm btn-main-color mx-auto ml-md-auto mr-md-0", type: "button", onClick: handleClickMypageEntry }, "\u540C\u610F\u3059\u308B"))))) : (
        // 同意文取得NG
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "alert alert-danger", role: "alert" }, error_message)))));
};
if (document.getElementById('guarantor-agreement-index')) {
    render(React.createElement(GuarantorAgreementIndex, null), document.getElementById('guarantor-agreement-index'));
}
